<template>
	<div class="storageoutprint" id="storageoutprint" :style="{ height: `${windowHeight}px`, 'overflow-y': 'scroll' }">
		<el-form>
			<el-card>
				<el-row class="formTitle">
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="is.weight" :true-label="1" :false-label="0" @change="ChangeWeightCkb"></el-checkbox>
							<span>称重</span>
						</label>
					</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="is.print" @change="ChangePrintCkb" :true-label="1" :false-label="0"></el-checkbox>
							<span>打单</span>
						</label>
					</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="is.logistic" :true-label="1" :false-label="0"></el-checkbox>
							<span>生成物流</span>
						</label>
					</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="is.checkcargo" :true-label="1" :false-label="0" @change="ChangeLogisticCkb"></el-checkbox>
							<span>验商品</span>
						</label>
					</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="sendremind" :true-label="1" :false-label="0"></el-checkbox>
							<span>发送提醒</span>
						</label>
					</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="showaddedservice" :true-label="1" :false-label="0" @change="ChangeServiceCkb"></el-checkbox>
							<span>增值服务</span>
						</label>
					</el-col>
					<el-col :span="9">
						<!-- <el-button type="primary" @click="openwtjin" size="small" style="padding-left:10px;">问题件入库</el-button> -->
						<handlerbutton :handlerlist="buttons" @buttonhandle="buttonhandle"></handlerbutton>
					</el-col>
				</el-row>
				<table style="width:99%">
					<tr>
						<td valign="top">
							<div class="formContent">
								<table class="htmltable">
									<tr>
										<td class="tdleft"><span>批 次 号</span></td>
										<td colspan="3">
											<el-input ref="handlebatch" @keyup.enter.native="EnterEvent('handlebatch')" @blur="updatebatch" v-model="form.handbatch"></el-input>
										</td>
									</tr>
									<tr v-show="!ishidclear">
										<td class="tdleft"><span>渠 道</span></td>
										<td>
											<el-select v-model="form.p_mode" @change="GetPrintMode">
												<el-option v-for="(opt, opti) in pmodelist" :key="opti" :value="opt.p_mode">{{ opt.p_mode }}</el-option>
											</el-select>
										</td>
										<td class="tdleft"><span v-show="is.print == 1">打印模板</span></td>
										<td>
											<el-select v-model="form.printmode" v-show="is.print == 1" @change="ChangePrintMode">
												<el-option v-for="(opt, opti) in printmode" :key="opti" :value="opt.id">{{ opt.e_shortname }}-{{ opt.e_modename }}</el-option>
											</el-select>
										</td>
									</tr>
									<tr v-for="c in trorder" v-if="c.isshow == 1">
										<td class="tdleft_bold">
											<span>
												<b>{{ c.lable }}</b>
											</span>
										</td>
										<td colspan="3" class="b_font">
											<el-input v-model="form.pkval" :ref="c.control" @keyup.enter.native="EnterEvent(c.control)" v-if="c.control == 'pkval'"></el-input>
											<el-input
												v-model="form.subpkval"
												:ref="c.control"
												@keyup.enter.native="EnterEvent(c.control)"
												v-if="c.control == 'subpkval'"
											></el-input>
											<el-input v-model="form.weight" :ref="c.control" @keyup.enter.native="EnterEvent(c.control)" v-if="c.control == 'weight'"></el-input>
										</td>
									</tr>
									<tr v-if="is.pay == 1">
										
										<td class="tdleft"><span>金 额</span></td>
										<td><el-input ref="fee" v-model="form.fee" @keyup.enter.native="EnterEvent('fee')" :readonly="true"></el-input></td>
										<td class="tdleft"><span>收费方式</span></td>
										<td>
											<el-select v-model="form.paytype">
												<el-option v-for="(opt, opti) in paytypelist" :key="opti" :value="opt.d_name">{{ opt.d_name }}</el-option>
											</el-select>
										</td>
										
									</tr>
									
									<tr v-if="is.logistic == 1">
										<td class="tdleft"><span>操作时间</span></td>
										<td colspan="3" style="text-align:left;">
											<el-date-picker v-model="form.wltime" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker>
										</td>
									</tr>
									<tr v-if="is.logistic == 1">
										<td class="tdleft"><span>操作描述</span></td>
										<td colspan="3"><el-input ref="wlcontent" v-model="form.wlcontent"></el-input></td>
									</tr>
								</table>
							</div>
						</td>
						<td valign="top" rowspan="2">
							<div class="formRight">
								<div class="perpkval">
									<span v-if="form.perpkval != ''">上一单 : {{ form.perpkval }}</span>
									<span v-if="errormsg != ''">{{ errormsg}}</span>
								</div>
								<div class="formtips" v-if="form.cargolist.length > 0">
									<label>
										<i class="el-icon-d-arrow-right"></i>
										包裹内容
									</label>
									<div class="cargocontent">
										<p v-for="cargo in form.cargolist">{{ cargo.cname }} {{ cargo.spec }} {{ cargo.num }}{{ cargo.unit }}</p>
									</div>
								</div>
							</div>
							<div class="formCargo" v-if="is.unpacking == 1">
								<label>
									<i class="el-icon-d-arrow-right"></i>
									子订单
								</label>
								<tableui style="width:100%;" editcell="0" :tableData="suborder" :columns="ordercolumns" :gridheight="suborderheight"></tableui>
							</div>
						</td>
					</tr>
					<tr>
						<td style="width:50%;">
							<div class="formCargo">
								<i class="el-icon-d-arrow-right"></i>
								<label>
									已扫描
									<span class="ordercount">{{ scanordercount }}</span>
									单
								</label>
								<label>
									总重量
									<span class="orderweight">{{ scanorderweight }}</span>
								</label>
							</div>
							<tableui
								style="width:99%;"
								ref="storageinout"
								:tableData="orderTable"
								:columns="scanordercolumns"
								@gridhandle="gridhandle"
								:gridheight="orderheight"
							></tableui>
						</td>
					</tr>
				</table>
			</el-card>
		</el-form>
		<!-- dialog2 -->
		<el-dialog
			title="验商品"
			:visible.sync="dialogverifycargo"
			width="40%"
			:modal-append-to-body="false"
			lock-scroll
			:show-close="false"
			:close-on-click-modal="false"
			@opened="setcargodialog('open')"
			@closed="setcargodialog('close')"
		>
			<el-row class="checkcargo">
				<table class="htmltable">
					<tr>
						<td valign="middle">
							<el-input
								v-model="cargobarcode"
								class="b_input"
								placeholder="请输入商品条码"
								ref="cargobarcode"
								@keyup.enter.native="EnterEvent('cargobarcode')"
							></el-input>
							<span>已扫描0个商品</span>
						</td>
						<td valign="middle">
							<div class="tCode"><img src="../../static/system_01/image/2.png" /></div>
							<div class="tips">跳过验货请扫描此条码</div>
						</td>
					</tr>
					<tr>
						<td colspan="2"><tableui style="width:100%;margin-top:10px" editcell="0" :tableData="form.cargolist" :columns="cargocolumns"></tableui></td>
					</tr>
				</table>
			</el-row>
		</el-dialog>
		<el-dialog
			title="扫描验证"
			:visible.sync="errorwin"
			width="30%"
			:modal-append-to-body="false"
			lock-scroll
			:show-close="false"
			:close-on-click-modal="false"
			@opened="setdialog('open')"
			@closed="setdialog('close')"
		>
			<div class="errorwin">
				<div class="errormsg">
					<span>{{ errormsg }}</span>
				</div>
				<div class="tips">请扫描下方条码或者在输入框中填写 1A 再回车</div>
				<div><el-input v-model="errorcode" ref="errorcode" @keyup.enter.native="EnterEvent('errorcode')"></el-input></div>
				<div class="barcode"><img src="../../static/system_01/image/tmA.png" /></div>
			</div>
		</el-dialog>
		<printhandler ref="printhandler"></printhandler>
		<addedservicehandle ref="addedservicehandle"></addedservicehandle>
		<useryubao ref="useryubao"></useryubao>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import printhandler from '@/components/order/printhandler.vue';
import Utils from '../../lib/util.js';
import addedservicehandle from '@/components/order/addedservice_handle.vue';
import useryubao from '@/components/order/useryubao.vue';

export default {
	components: {
		tableui,
		printhandler,
		addedservicehandle,
		handlerbutton,
		useryubao
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			buttons:[],
			batch: '', //当前操作界面生成的临时批次号,可用于收费(暂时无用)
			fun: '入库',
			isin: 1, //是否入库 
			checkpmodetype: 0, //验证出入库渠道方式 0-不验证口岸，也不更新口岸， 1-验证渠道，不一致的直接提示 2-不验证口岸，直接将界面上的口岸更新给订单
			scanordercount: 0,
			scanorderweight: 0,
			scanorderamount: 0.0,
			errorcode: '', //错误码扫描
			errormsg: '',
			currentstate: '', //当前操作状态
			errorfocus: false,
			windowHeight: (window.innerHeight * 88) / 100,
			orderheight: (window.innerHeight * 33) / 100 + 'px',
			suborderheight: (window.innerHeight * 35) / 100 + 'px',
			huojia: '', //货架
			dialogauto: false,
			dialogverifycargo: false,
			errorwin: false,
			l_name: '', //操作方式
			orderTable: [],
			is: {
				unpacking: 0, //拆包验货
				checkcargo: 0, //验商品
				auto: 0, //自动上架
				pay: 0, //是否收费
				weight: 0, //称重
				print: 0, //打单
				logistic: 0, //生成物流
				isweightfirst: 0 ,//是否先称重后扫单，或者先扫单后称重
				photo:0 //拍照
			},
			form: {
				handlepkval: '', //实际操作的订单号
				pkval: '',
				subpkval: '',
				weight: '',
				handbatch: '',
				paytype: '',
				p_mode: '',
				printmode: '',
				shelves: '', //操作货架
				e_code: '',
				perpkval: '',
				wlcontent: '',
				wltime: '',
				fee: 0.0,
				other_fee: 0.0,
				cargolist: [],
				p_bagsort: '',
				vipaccount: '',
				ischeckpmode: 0,
				orderinfo: [],
				checkedcargo: false ,//商品是否验证完成
				p_remark:''//备注
			},
			scanedperpkval:'',//已扫描的上一单
			pkvals: '', //如果扫描的是国内快递单号的话，有可能是多个订单号
			suborder: [],
			suborderscaned:[],//已扫描子单
			ordercolumns: [
				{ field: 'p_pkval', title: '单号', type: 'text', width: '100', sortable: false },
				{ field: 'remark', title: '详情', type: 'text', width: '120', sortable: false }
			],
			scanordercolumns: [
				{ field: 'p_pkval', title: '单号', type: 'text', width: '100', sortable: false },
				//{ field: 'ctname', title: '发件人', type: 'text', width: '120', sortable: false },
				{ field: 'remark', title: '详情', type: 'text', width: '150', sortable: false },
				{
					field: '',
					title: '操作',
					type: 'template',
					width: '80',
					sortable: false,
					template: [{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'removecheck' }]
				}
			],
			cargocolumns: [
				{ field: 'cname', title: '商品', type: 'text', width: '120', sortable: false },
				{ field: 'num', title: '数量', type: 'text', width: '120', sortable: false }
			],
			pmodelist: [], //渠道
			printmode: [], //打印模板
			shelveslist: [], //货架选项列表
			shelveslist: [], //操作仓库选项
			selectedpmodeindex: 0,
			selectedprintindex: 0,
			paytypelist: [],
			subscanfilish: false, //子单是否扫描完成
			trorder: [{ lable: '单 号', control: 'pkval', isshow: 1 }, { lable: '子单号', control: 'subpkval', isshow: 0 }, { lable: '重 量', control: 'weight', isshow: 0 }],
			localprinter: '',
			cargobarcode: '', //验商品扫码
			userid: localStorage.getItem('userid'),
			u_name: localStorage.getItem('u_name'),
			u_account: localStorage.getItem('u_account'),
			u_company: localStorage.getItem('u_company'),
			ishidclear: true,
			divclass: 'storageoutprint',
			isstop:0,
			tempres:'',
			errorbatch:'',//问题件批次
			sendremind:0,
			wlset:{},
			showaddedservice:0
		};
	},
	mounted() {
		if (this.urlparam.l_name != undefined) {
			this.l_name = this.urlparam.l_name;
		}
		if (this.urlparam.isin != undefined) {
			this.isin = this.urlparam.isin;
			if (this.isin == 1) this.fun = '入库';
			else this.fun = '出库';
		}
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/wm/storageprint.scss');
		});
		this.LoadStoragePrintPage();
		//this.GetPaytype();
		var that=this;
		this.$nextTick(function() {
			if(that.form.handbatch=='')
				that.$refs.handlebatch.focus();
			else{
				that.$refs.shelves.focus();
			}	
		});
	},
	methods: {
		//获取勾选参数
		LoadStoragePrintPage() {
			var that = this;
			var paraminfo = {
				isin: this.isin,
				userid: localStorage.getItem('userid')
			};
			this.$apipost.get.LoadStoragePrintPage({ paraminfo: paraminfo }).then(res => {
				if (res != '') {
					that.is = res.userparam;
					that.buttons=res.buttons;
					if (res.wlset != undefined) {
						that.wlset = res.wlset;
						if (res.wlset.w_context != undefined) {
							that.form.wlcontent = res.wlset.w_context;
						}
					}
					that.pmodelist = res.clearance;
					if (that.pmodelist.length > 0) {
						that.form.p_mode = that.pmodelist[0].p_mode;
						if (that.isin == 1) {
							that.ishidclear = true;
						}
						that.form.handbatch = res.handbatch;
						that.selectedpmodeindex = 0;
						if (that.is.print == 1) that.ChangePrintCkb();
					}
					that.shelveslist = res.shelves;
					if (that.shelveslist.length == 1) that.form.shelves = that.shelveslist[0].d_name;
					if (that.is.isweightfirst == 1) {
						that.trorder = [
							{ lable: '重 量', control: 'weight', isshow: 0 },
							{ lable: '单 号', control: 'pkval', isshow: 1 },
							{ lable: '子单号', control: 'subpkval', isshow: 0 }
						];
						if (that.is.weight == 1) {
							that.trorder[0].isshow = 1;
						}
						if (that.is.unpacking == 1) {
							that.trorder[2].subpkval = 1;
						}
					} else {
						if (that.is.weight == 1) {
							that.trorder[2].isshow = 1;
						}
						if (that.is.unpacking == 1) {
							that.trorder[1].subpkval = 1;
						}
					}
					that.GetOrderlist();
				}
			});
		},
		//渠道更改时，获取对应打印模板
		GetPrintMode(p_mode) {
			this.form.p_mode = p_mode;
			for (var i = 0; i < this.pmodelist.length; i++) {
				if (this.pmodelist[i].p_mode == p_mode) {
					this.selectedpmodeindex = i;
					break;
				}
			}
			if (this.is.print == 1) {
				this.GetPrintBzMode();
			}
		},
		//勾选打单
		ChangePrintCkb(value) {
			if (value == 1) {
				this.ishidclear = false;
				if (this.$tool.checkprintcontrol()) {
					this.GetPrintBzMode();
				} else {
					this.$tool.opendowncontrol();
				}
			} else {
				if (this.checkpmodetype == 0) this.ishidclear = true;
				else this.ishidclear = false;
			}
		},
		//获取打印模板
		GetPrintBzMode() {
			var that = this;
			if (this.pmodelist[this.selectedpmodeindex].p_mode != undefined) {
				this.$apipost.get.GetPrintBzMode({ p_mode: this.pmodelist[this.selectedpmodeindex].p_mode }).then(res => {
					if (res != '') {
						if (res.list != '') {
							that.printmode = res.list;
							that.form.printmode = res.list[0].e_shortname + '-' + res.list[0].e_modename;
							that.selectedprintindex = 0;
							that.form.e_code = res.list[0].id;
						}
					}
				});
			}
		},
		//打印模板切换时触发
		ChangePrintMode(value) {
			for (var i = 0; i < this.printmode.length; i++) {
				if (this.printmode[i].id == value) {
					this.selectedprintindex = i;
					break;
				}
			}
			this.form.printmode = this.printmode[this.selectedprintindex].e_shortname + '-' + this.printmode[this.selectedprintindex].e_modename;
			this.form.e_code = this.printmode[this.selectedprintindex].id;
		},
		//获取支付方式
		async GetPaytype() {
			var that = this;
			this.$apipost.get.dic({ type: '支付方式' }).then(res => {
				if (res != '') {
					that.paytypelist = res.data.list;
					if (res.data.list.length > 0) that.form.paytype = res.data.list[0].d_name;
				}
			});
		},
		//列表操作栏事件
		gridhandle(e) {
			if (e.event == 'removecheck') {
				this.RollbackStorage(this.orderTable[e.index].pkvals, parseInt(e.index));
			}
		},
		//文本框回调事件
		EnterEvent(control) {
			this.currentstate = control;
			if (control == 'weight') {
				if (isNaN(Number(this.form.weight)) || this.form.weight <= 0) {
					this.form.weight = '';
					return false;
				}
				if (this.is.isweightfirst == 1) {
					if (this.form.pkval == '') {
						if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
						else this.$refs.pkval.focus();
					} else {
						if (this.$refs.subpkval[0] != undefined) this.$refs.subpkval[0].focus();
						else this.$refs.subpkval.focus();
					}
				} else {
					//走下一步判断是否收费，不收费则直接入库，收费则计算费用
					if (this.is.pay == 1) {
						//计算费用
						this.StorageInOutHandle(2, 0);
					} else {
						if (this.is.logistic == 1) {
							if (this.form.wlcontent == '') {
								if (this.$refs.wlcontent[0] != undefined) this.$refs.wlcontent[0].focus();
								else this.$refs.wlcontent.focus();

								// that.errormsg = '请输入操作描述';
								// that.errorwin = true;
								that.ReadMsg('请输入操作描述');
								return false;
							}
						}
						//入库/出库
						this.StorageInOutHandle(3, 0);
					}
				}
			}
			if (control == 'pkval') {
				//获取订单信息
				this.form.pkval = this.form.pkval.trim();
				this.ScanPkVal(this.currentstate);
			}
			if (control == 'subpkval') {
				this.form.subpkval = this.form.subpkval.trim();
				if (this.form.subpkval != '') {
					this.ScanPkVal(this.currentstate);
				}
			}
			if(control=='handlebatch')
			{
				if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
				else this.$refs.pkval.focus();
				// if (this.$refs.shelves[0] != undefined) this.$refs.shelves[0].focus();
				// else this.$refs.shelves.focus();
			}
			if (control == 'shelves') {
				if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
				else this.$refs.pkval.focus();
			}
			if (control == 'fee') {
			// 	if (this.$refs.other_fee[0] != undefined) this.$refs.other_fee[0].focus();
			// 	else this.$refs.other_fee.focus();
			// }
			// if (control == 'other_fee') {
				this.StorageInOutHandle(3, 0);
			}
			if (control == 'cargobarcode') {
				this.cargobarcode = this.cargobarcode.trim();
				this.ScanCargo();
			}
		},
		//扫描单号触发事件
		ScanPkVal(type) {
			var isgo = true;
			if (this.form.handbatch == '') {
				this.$tool.message('请输入批次号', 2);
				this.ReadMsg('请输入批次号');
				isgo = false;
			}
			// if (this.form.shelves == '') {
			// 	this.$tool.message('请选择货架', 2);
			// 	LODOP.FORMAT('VOICE:3;100', '请选择货架');
			// 	isgo = false;
			// }
			if (type == 'pkval') {
				if (this.form.pkval == '') isgo = false;
			} else if (type == 'subpkval') {
				if (this.form.subpkval == '') isgo = false;
			}
			if (isgo) {
				this.StorageInOutHandle(1, 0);
			} else {
				this.form.pkval = '';
				this.form.subpkval = '';
				this.form.weight = '';
			}
		},
		//出入库操作 1-获取订单详情 2-计算费用 3-出入库操作
		StorageInOutHandle(handletype, index) {
			var that = this;
			var isgo = true;
			if (handletype != 1) {
				//这个判断是防止用户手动输入单号未回车，直接鼠标切换到其他输入框的情况
				if (that.form.handlepkval == '' || that.form.handlepkval == undefined) {
					if (that.is.unpacking == 1) {
						if (that.form.pkval != '' && that.form.subpkval != '') {
							if (that.$refs.subpkval[0] != undefined) that.$refs.subpkval[0].focus();
							else that.$refs.subpkval.focus();
						} else if (that.form.pkval != '' && that.form.subpkval == '') {
							if (that.$refs.pkval[0] != undefined) that.$refs.pkval[0].focus();
							else that.$refs.pkval.focus();
						}
					} else {
						if (that.$refs.pkval[0] != undefined) that.$refs.pkval[0].focus();
						else that.$refs.pkval.focus();
					}
					isgo = false;
				}
			}
			if (isgo) {
				var pkvallist = [this.form.pkval];
				if (handletype == 3) {
					pkvallist = that.pkvals.split('★');
				}
				//debugger
				if (pkvallist.length - 1 >= index) {
					this.$tool.loading('正在操作', this.divclass);
					if (handletype == 3) this.form.handlepkval = pkvallist[index];
					var paraminfo = {
						handletype: handletype,
						pageparam: this._data
					};
					// console.log('入库参数',escape(JSON.stringify(paraminfo)));
					// return false;
					this.$apipost.post
						.StorageInOutHandle({
							paraminfo: paraminfo
						})
						.then(res => {
							this.$tool.loadingclose();
							if (res != '') {
								if (handletype == 1)
									//获取订单信息
									that.HandleOrderInfo(res);
								//处理订单信息
								else if (handletype == 2) that.HandlePayinfo(res);
								else if (handletype == 3) that.HandleInOut(res, index, pkvallist);
							} else {
								 this.errormsg = '系统异常，请重试';
								// this.errorwin = true;
								this.ReadMsg('系统异常，请重试');
								index = pkvallist.length + 1;
								that.StorageInOutHandle(handletype, index);
							}
						});
				} else {
					if (pkvallist.length == index) {
						if(this.is.logistic==1)
							that.CreateStep();
						if(this.sendremind==1)
							that.$tool.SendMessage(
						{msgid:'276-1',info:that._data,pkval:that.form.handlepkval,type:'1-q',showerror:false},that);
						if(this.showaddedservice==1){
							//如果订单是有增值服务的，则弹出
							if(that.form.orderinfo.intercept.indexOf('操作状态')>-1){
								if(this.$refs.addedservicehandle!=undefined){
									this.$refs.addedservicehandle.init({p_pkval:this.form.handlepkval});
								}
							}
						}
						//订单添加到已扫描表中
						that.addOrderList();
						//清空值，准备扫下一个单
						that.ClearInput();
					}
				}
			}
		},
		CreateStep(){
			this.$apipost.post
				.CreateStep({
					pkval: this.form.handlepkval,
					batch:'',
					fun:this.fun,
					context:this.form.wlcontent,
					createtime:this.$tool.formatdate(this.form.wltime)
				})
				.then(res => {
					
				});
		},
		//处理订单信息
		HandleOrderInfo(res) {
			//debugger
			var that = this;
			//if (res.state == '1') {
				that.pkvals = '';
				if(res.message!=undefined){
					this.ReadMsg(res.message);
					this.errormsg=res.message;
					this.errorbatch=this.form.handbatch;
				}
				if(res.orderinfo!=undefined){
					if(res.orderinfo.length>0){
						that.form.p_bagsort = res.orderinfo[0].p_bagsort;
						that.form.vipaccount = res.orderinfo[0].vipaccount;
						that.form.ischeckpmode = res.orderinfo[0].ischeckpmode;
						that.form.handlepkval = res.orderinfo[0].p_pkval;
						that.form.cargolist = res.cargolist;
						that.form.orderinfo = res.orderinfo[0];
						if(res.message!=undefined)
							that.form.p_remark=res.message;
						res.orderinfo.forEach(e => {
							that.pkvals += e.p_pkval + '★';
						});
					}
					else{
						if(res.message!=undefined)
							that.form.p_remark=res.message;
						if(this.is.unpacking==0){
							that.pkvals=this.form.pkval + '★';
							that.form.handlepkval=this.form.pkval;
						}else{
							that.pkvals=this.form.subpkval + '★';
							that.form.handlepkval=this.form.subpkval;
						}
					}
				}
				else{
					if(that.is.unpacking==1)
						that.form.subpkval='';
					else
						that.form.pkval='';
					return false;
				}
				if (that.pkvals != '') {
					that.pkvals = that.pkvals.substring(0, that.pkvals.length - 1);
				}
				if (res.suborderlist!=undefined) {
					if(res.suborderlist.length>0){
						//如果有子单，则显示
						that.suborder = res.suborderlist;
						that.is.unpacking = 1;
						that.ChangePackCkb(true);
						that.$nextTick(function() {
							if (that.$refs.subpkval[0] != undefined) that.$refs.subpkval[0].focus();
							else that.$refs.subpkval.focus();
						});
										
						that.pkvals = '';
						return false;
					}
				}
				if (that.is.isweightfirst == 0) {
					if (that.is.pay == 1 || that.is.weight == 1) {
						if (that.$refs.weight[0] != undefined) that.$refs.weight[0].focus();
						else that.$refs.weight.focus();
						return false;
					}
				}
				if (that.is.checkcargo == 1) {
					that.dialogverifycargo = true;
					return false;
				}
				if (that.is.auto == 1) {
					that.dialogauto = true;
					return false;
				}
				if (that.is.logistic == 1) {
					if(that.form.wltime==''){
						//that.errormsg = ;
						//that.errorwin = true;
						this.ReadMsg('请输入操作时间');
						return false;
					}
					if (that.form.wlcontent == '') {
						if (that.$refs.wlcontent[0] != undefined) that.$refs.wlcontent[0].focus();
						else that.$refs.wlcontent.focus();
						this.ReadMsg('请输入操作描述');
						// that.errormsg = ;
						// that.errorwin = true;
						return false;
					}
				}
				that.StorageInOutHandle(3, 0); //调用保存出入库
			//} else {
				//弹出错误
				//that.tempres=res;
				//that.isstop=res.isstop;
				//that.errormsg = res.message;
				//that.errorwin = true;
				//this.ReadMsg(res.message);
			//}
		},
		//处理计算费用结果
		HandlePayinfo(res) {
			// if (res.state == '1') {
			// 	this.form.fee = res.amount;
			// 	// if (this.$refs.other_fee[0] != undefined) this.$refs.other_fee[0].focus();
			// 	// else this.$refs.other_fee.focus();
			// 	this.StorageInOutHandle(3, 0);
			// } else {
			// 	this.errormsg = res.message;
			// 	this.errorwin = true;
			// }
		},
		//处理出入库结果
		HandleInOut(res, index, pkvallist) {
			var that = this;
			if (res.state != undefined) {
				if (res.state == '1') {
					index = index + 1;
					if(that.errormsg=='')
						that.ReadMsg(that.fun+'成功');
					that.StorageInOutHandle(3, index);
				} else {
					
					 that.errormsg = res.message;
					// this.errorwin = true;
					that.ReadMsg(res.message);
					//index = pkvallist.length + 1;
					index=index+1;
					that.StorageInOutHandle(3, index);
				}
			} else {
				if (res.indexOf('LODOP') > -1) {
					eval(res);
					index = index + 1;
					that.StorageInOutHandle(3, index);
				} else {
					this.errormsg = res.message;
					//this.errorwin = true;
					//index = pkvallist.length + 1;
					index = index + 1;
					this.ReadMsg(res.message);
					that.StorageInOutHandle(3, index);
				}
			}
		},
		//添加
		addOrderList() {
			var orderinfo = [];
			if (this.is.unpacking == 1){
				orderinfo = [
					{
						p_pkval: this.form.subpkval,
						//ctname: this.form.orderinfo.ctname,
						remark:'称重重量: ' + this.form.weight,
						weight: this.form.weight,
						fee: parseFloat(this.form.fee) + parseFloat(this.form.other_fee),
						pkvals: this.form.handlepkval,
						expressid_gn:this.form.orderinfo.expressid_gn
					}
				];
				this.SetSubMark(this.form.subpkval);
			}
			else {
				orderinfo = [
					{
						p_pkval: this.form.pkval,
						//ctname: this.form.orderinfo.ctname,
						remark:'称重重量: ' + this.form.weight ,
						weight: this.form.weight,
						fee: parseFloat(this.form.fee) + parseFloat(this.form.other_fee),
						pkvals: this.form.handlepkval,
						expressid_gn:this.form.orderinfo.expressid_gn
					}
				];
			}
			if (this.orderTable.length == 0) this.orderTable = orderinfo;
			else {
				this.orderTable.splice(0, 0, orderinfo[0]);
			}
		},
		//打开关闭错误扫码窗口时的回调操作
		setdialog(type) {
			if (type == 'open') {
				this.ReadMsg(this.errormsg);
				this.$refs.errorcode.focus();
			} else if (type == 'close') {
				// if(this.isstop==0)
				// {
				// 	this.isstop=1;
				// 	return false;
				// }
				if (this.currentstate == 'pkval') {
					this.form.pkval = '';
					if (this.is.isweightfirst == '1') {
						if (this.$refs.weight[0] != undefined) this.$refs.weight[0].focus();
						else this.$refs.weight.focus();
					} else {
						if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
						else this.$refs.pkval.focus();
					}
				} else if (this.currentstate == 'subpkval') {
					this.form.subpkval = '';
					if (this.is.isweightfirst == '1') {
						if (this.$refs.weight[0] != undefined) this.$refs.weight[0].focus();
						else this.$refs.weight.focus();
					} else {
						if (this.$refs.subpkval[0] != undefined) this.$refs.subpkval[0].focus();
						else this.$refs.subpkval.focus();
					}
				} else if (this.currentstate == 'weight') {
					this.form.weight = '';
					if (this.$refs.weight[0] != undefined) this.$refs.weight[0].focus();
					else this.$refs.weight.focus();
				} else if (this.currentstate == 'fee') {
					this.form.fee = 0;
					if (this.$refs.fee[0] != undefined) this.$refs.fee[0].focus();
					else this.$refs.fee.focus();
				} else if (this.currentstate == 'other_fee') {
					this.form.other_fee = 0;
					if (this.$refs.other_fee[0] != undefined) this.$refs.other_fee[0].focus();
					else this.$refs.other_fee.focus();
				} else if (this.currentstate == 'cargobarcode') {
					this.cargobarcode = '';
					if (this.$refs.cargobarcode[0] != undefined) this.$refs.cargobarcode[0].focus();
					else this.$refs.cargobarcode.focus();
				}
			}
		},
		//关闭验商品窗口
		setcargodialog(type) {
			if (type == 'open') {
				if (this.$refs.cargobarcode[0] != undefined) this.$refs.cargobarcode[0].focus();
				else this.$refs.cargobarcode.focus();
			} else if (type == 'close') {
				this.cargobarcode = '';
			}
		},
		//设置子单标记
		SetSubMark(subpkval) {
			var that = this;
			var suborder = this.suborder;
			for (var i = 0; i < suborder.length; i++) {
				if (suborder[i].p_pkval.toLowerCase() == subpkval.toLowerCase()) {
					this.suborderscaned.push(suborder[i]);
					suborder.splice(i, 1);
					break;
				}
				else if (suborder[i].expressid.toLowerCase() == subpkval.toLowerCase()) {
					this.suborderscaned.push(suborder[i]);
					suborder.splice(i, 1);
					break;
				}
			}
			if (suborder.length == 0) {
				this.subscanfilish = true;
			}
		},
		eventHandle(index) {
			if (index == 1) {
				this.$refs.weight[0].focus();
				this.dialogauto = false;
			}
		},
		//清空文本框
		ClearInput() {
			//debugger
			this.ScanSum();
			this.scanedperpkval=this.form.handlepkval;
			
			this.form.perpkval=this.form.pkval+'  重量 : 【'+this.form.weight+'】'+this.errormsg;
			//this.pkvals = '';
			if(this.is.unpacking==1){
				this.form.perpkval = this.form.subpkval+'  重量 : 【'+this.form.weight+'】   '+this.errormsg;
			}else{
				this.form.pkval = '';
			}
			this.errorbatch='';
			this.form.subpkval = '';
			this.form.handlepkval = '';
			this.form.weight = '';
			this.form.fee = 0;
			this.form.other_fee = 0;
			this.form.p_bagsort = '';
			this.form.p_remark='';
			this.errormsg='';
			//设置焦点定位
			if (this.is.weight == 1 && this.is.isweightfirst == 1) {
				//如果有勾选称重
				if (this.$refs.weight[0] != undefined) this.$refs.weight[0].focus();
				else this.$refs.weight.focus();
			} else {
				if (this.is.unpacking == 1) {
					if (this.subscanfilish) {
						//如果子单扫描完成，则跳转到单号输入框
						if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
						else this.$refs.pkval.focus();
						this.suborder = [];
						this.form.pkval = '';
						this.form.cargolist = [];
						this.is.unpacking=0;
						this.subscanfilish = false;
						this.ChangePackCkb(false);
					} else {
						if (this.$refs.subpkval[0] != undefined) this.$refs.subpkval[0].focus();
						else this.$refs.subpkval.focus();
					}
				} else {
					if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
					else this.$refs.pkval.focus();
				}
			}
		},
		ScanSum() {
			//计算汇总
			this.scanordercount = this.orderTable.length;
			var scanorderweight = 0,
				scanorderamount = 0.0;
			this.orderTable.forEach(e => {
				if (Number(e.weight)>0) scanorderweight += parseFloat(e.weight);

				if (Number(e.fee)>0) scanorderamount +=parseFloat(e.fee);
			});
			this.scanorderweight = scanorderweight.toFixed(3);
			this.scanorderamount = scanorderamount.toFixed(2);
		},
		//回滚
		RollbackStorage(pkvals, orderindex) {
			var that = this;
			var paraminfo = { pageparam: { isin: this.isin, pkvals: pkvals, is: this.is, form: this.form,userid:localStorage.getItem('userid') } };
			this.$apipost.post
				.RollbackStorage({
					paraminfo: paraminfo
				})
				.then(res => {
					if (res.state == 1) {
						this.$tool.message('删除成功', 1);
						var removetr=that.orderTable[orderindex];
						if(removetr.expressid_gn==that.form.pkval)
						{
							//如果删除的包裹单号与主单号一致，则将已扫描的子单号与当前移除的子单号一致的记录回添加到右边子订单列表中，并移除已扫描子单记录中对应的单号
							for(var i=0;i<that.suborderscaned.length;i++){
								if(that.suborderscaned[i].p_pkval.toLowerCase()==removetr.p_pkval.toLowerCase()){
									that.suborder=that.suborder.concat(JSON.parse(JSON.stringify(that.suborderscaned[i])));
									that.suborderscaned.splice(i,1);
									break;
								}
							}
						}
						that.orderTable.splice(orderindex, 1);
						//如果是子单，且是当前正在操作的子单，则添加回右边列表中
						that.ScanSum();
					} else {
						this.$tool.message('删除失败', 0);
					}
				});
		},
		//扫描商品
		ScanCargo() {
			if (this.cargobarcode != '') {
				if (this.cargobarcode == '2') {
					this.scancargofinished(0);
				} else {
					var cargolist = this.form.cargolist;
					var isexists = false;
					for (var i = 0; i < cargolist.length; i++) {
						if (cargolist[i].barcode.trim() == this.cargobarcode.trim()) {
							isexists = true;
							if (cargolist[i].scannum == cargolist[i].num) {
								this.errormsg = '此商品已扫描';
								this.errorwin = true;
							} else cargolist[i].scannum = parseInt(cargolist[i].scannum) + 1;
							break;
						}
					}
					if (!isexists) {
						this.errormsg = '此商品条码不属于当前订单';
						this.errorwin = true;
						return false;
					}
					//检测是否所有商品都扫描完成
					var checkscan = cargolist.filter(item => item.scannum != item.num);
					if (checkscan.length == 0) {
						this.scancargofinished(1);
					} else {
						this.cargobarcode = '';
						this.$refs.cargobarcode.focus();
					}
				}
			}
		},
		//验商品扫描完成
		scancargofinished(ischecked) {
			this.dialogverifycargo = false;
			this.form.checkedcargo = ischecked;
			if (this.is.auto == 1) {
				this.dialogauto = true;
				return false;
			}
			if (this.is.weight == 1) {
				if (this.isweightfirst == 1) {
					if (this.is.fee == 1)
						//调用收费
						this.StorageInOutHandle(2, 0);
					//调用保存出入库
					else this.StorageInOutHandle(3, 0);
				} else {
					if (this.$refs.weight[0] != undefined) this.$refs.weight[0].focus();
					else this.$refs.weight.focus();
				}
			} else {
				this.StorageInOutHandle(3, 0);
			}
		},
		//更改选择重量复选框时
		ChangeWeightCkb(value) {
			for (var i = 0; i < this.trorder.length; i++) {
				if (this.trorder[i].control == 'weight') {
					this.trorder[i].isshow = value;
					if(value==1)
					{
						if(this.is.unpacking==1&&this.form.pkval!=''){
							
							if (this.$refs.subpkval[0] != undefined) this.$refs.subpkval[0].focus();
							else this.$refs.subpkval.focus();
						}else{
							if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
							else this.$refs.pkval.focus();
						}
					}
					break;
				}
			}
		},
		//当订单有子单时触发
		ChangePackCkb(value) {
			for (var i = 0; i < this.trorder.length; i++) {
				if (this.trorder[i].control == 'subpkval') {
					this.trorder[i].isshow = value;
					break;
				}
			}
		},
		ChangeLogisticCkb(value){
			if(value){
				this.form.wltime=this.$tool.formatdate();
			}else{
				this.form.wltime='';
			}
		},
		//更新出入库批次号
		updatebatch() {
			var newbatch = this.form.handbatch;
			if (newbatch != '') {
				var that = this;
				var paraminfo = { handbatch: this.form.handbatch, fun: this.fun, userid: localStorage.getItem('userid') };
				this.$apipost.post
					.UpdateOutBatch({
						paraminfo: paraminfo
					})
					.then(res => {
						that.GetOrderlist();
					});
			}
		},
		//根据批次号获取所有已扫描订单
		GetOrderlist(){
			var that=this;
			this.$apipost.get
				.GetOrderlistByBatch({
					handbatch: this.form.handbatch,
					isin:this.isin
				})
				.then(res => {
					if(res.state=='1'){
						that.orderTable=res.list;
						that.ScanSum();
					}
				});
		},
		ReadMsg(msg){
			if(this.$tool.checkprintcontrol()){
				LODOP.FORMAT('VOICE:3;100', msg);
			}
		},
		//勾选增值服务时，如果有操作过的单，直接打开增值服务窗口 
		ChangeServiceCkb(value){
			if(value){
				if(this.scanedperpkval!=''){
					if(this.$refs.addedservicehandle!=undefined){
						this.$refs.addedservicehandle.init({p_pkval:this.scanedperpkval});
					}
				}
			}
		},
		buttonhandle(e) {
			if (e.event == 'wtjin') {//问题件入库
				Utils.$emit('go', { l_url: '/wm/wtjin', l_id:e.l_id, l_name:e.l_name, urlparam: {batch:this.form.handbatch,pkval:this.form.pkval} });
			}
			if(e.event=='takephoto'){//拍照
				Utils.$emit('go', { l_url: '/index/takephoto', l_id:e.l_id, l_name:e.l_name, urlparam: {pkval:this.form.pkval} });
			}
			if(e.event=='yubao'){
				if(this.$refs.useryubao!=undefined){
					this.$refs.useryubao.init();
				}
			}
		},
		openwtjin(){
			Utils.$emit('go', { l_url: '/wm/wtjin', l_id:284, l_name: '问题件入库', urlparam: {batch:this.form.handbatch,pkval:this.form.pkval} });
		}
	}
};
</script>
